
import { defineComponent } from "vue";

export default defineComponent({
	name: "DialogComponent",
	emits: ["answerClicked", "setAnswer", "close", "closeQuiz"],
});
